(function () {
  "use strict";
  var FR_GIFT_MAP = {
      56927458623872: 58119292420480,
      56927458951552: 58119291568512,
      57275393245568: 58119166427520,
      56983200432512: 58119285571968,
      5698287e7: 58119285637504,
      56982744596864: 58119285735808,
      56982734569856: 58119285801344,
      56982725722496: 58119285866880,
      56982717366656: 58119285965184,
      56982710747520: 58119286030720,
      56982700097920: 58119286260096,
      56981848850816: 58119286423936,
      56927453872512: 58119296188800,
      56927455019392: 58119296123264,
      56927455936896: 58119295861120,
      56927456395648: 58119295369600,
      56927456526720: 58119295009152,
      56927456854400: 58119294452096,
      56927457116544: 58119294091648,
      56927457542528: 58119293829504,
      56927457640832: 58119293534592,
      56927458001280: 58119292977536,
      56976303554944: 58119286587776,
      56927458722176: 58119292158336,
      56927459049856: 58119291306368,
      56976303260032: 58119286718848,
      56927459508608: 58119291044224,
      56927459639680: 58119290749312,
      56927459901824: 58119290028416,
      56927460098432: 58119289766272,
      56927460458880: 58119289405824,
      56927460589952: 58119289143680,
      56927460950400: 58119288521088,
      56927461048704: 58119288226176,
      56927461147008: 58119287669120,
      56927461376384: 58119287374208,
      56927461605760: 58119287243136,
      56927461704064: 58119287144832,
      56927461835136: 58119287079296,
      56927461933440: 58119287013760,
      56927462031744: 58119286948224,
      56927462916480: 58119286817152,
    },
    FR_GIFT_BAG_VARIANT_ID = 58146955166080,
    ALL_SAMPLE_IDS = new Set(
      Object.keys(FR_GIFT_MAP).map(function (id) {
        return FR_GIFT_MAP[id];
      }),
    ),
    ALL_GIFT_IDS = new Set(
      Array.from(ALL_SAMPLE_IDS).concat([FR_GIFT_BAG_VARIANT_ID]),
    ),
    syncPromise = null,
    syncQueued = !1,
    debounceTimer = null,
    scheduledCart = null;
  var giftFetch = window.fetch.bind(window);
  var pendingCartWrites = new Set();
  var checkoutPending = false;
  var checkoutApproved = false;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : input && input.url;
    var mutation = false;
    try {
      var parsed = new URL(url, window.location.href);
      mutation = parsed.origin === window.location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(parsed.pathname);
    } catch (error) {}
    var request = giftFetch(input, init);
    if (mutation) {
      pendingCartWrites.add(request);
      request.then(function () {
        pendingCartWrites.delete(request);
        debouncedSync();
      }, function () { pendingCartWrites.delete(request); });
    }
    return request;
  };

  async function verifyCheckout() {
    clearTimeout(debounceTimer);
    scheduledCart = null;
    while (pendingCartWrites.size) await Promise.allSettled(Array.from(pendingCartWrites));
    if (syncPromise) await syncPromise;
    return syncGifts();
  }

  function checkoutError() {
    window.alert("We couldn't check your included items. Please try checkout again.");
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    verifyCheckout().then(function () {
      window.location.assign(url.href);
    }).catch(checkoutError).finally(function () { checkoutPending = false; });
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart"]')) return;
    var button = event.submitter;
    if (checkoutApproved) return;
    if (button && button.name !== "checkout") return;
    if (!button && !form.querySelector('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    verifyCheckout().then(function (cart) {
      form.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
        var line = cart.items.find(function (item) { return item.key === input.dataset.id; });
        if (line) input.value = line.quantity;
        else input.disabled = true;
      });
      checkoutApproved = true;
      try { form.requestSubmit(button || form.querySelector('[name="checkout"]')); }
      finally { checkoutApproved = false; }
    }).catch(checkoutError).finally(function () { checkoutPending = false; });
  }, true);

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) syncGifts().catch(function () {});
  });
  document.addEventListener("cart:updated", function () { debouncedSync(); });

  function getCart() {
    return giftFetch("/cart.js", {
      headers: { Accept: "application/json" },
      cache: "no-store",
      credentials: "include",
    }).then(function (res) {
      if (!res.ok)
        throw new Error("Unable to read cart (HTTP " + res.status + ")");
      return res.json();
    });
  }
  function addItems(items) {
    return items.length
      ? giftFetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: items }),
          credentials: "include",
        }).then(function (res) {
          return res.ok
            ? res.json()
            : res
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (err) {
                  throw new Error(
                    err.description ||
                      "Unable to add gifts (HTTP " + res.status + ")",
                  );
                });
        })
      : Promise.resolve();
  }
  function buildGiftItemsForPaidItems(paidItems) {
    var neededSamples = {},
      bottleCount = 0;
    (paidItems || []).forEach(function (item) {
      var variantId = Number(item && (item.variant_id || item.id)),
        sampleId = FR_GIFT_MAP[variantId];
      if (sampleId !== void 0) {
        var quantity = Number(item.quantity || 1);
        ((!quantity || quantity < 1) && (quantity = 1),
          (bottleCount += quantity),
          (neededSamples[sampleId] =
            (neededSamples[sampleId] || 0) + quantity));
      }
    });
    var gifts = Object.keys(neededSamples).map(function (sampleId) {
      return {
        id: Number(sampleId),
        quantity: neededSamples[sampleId],
        properties: { _gift: "true" },
      };
    });
    return (
      bottleCount > 0 &&
        gifts.push({
          id: FR_GIFT_BAG_VARIANT_ID,
          quantity: bottleCount,
          properties: { _gift: "true" },
        }),
      gifts
    );
  }
  function addForPaidItems(paidItems) {
    return addItems(buildGiftItemsForPaidItems(paidItems));
  }
  function updateLines(updates) {
    return Object.keys(updates).length
      ? giftFetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ updates: updates }),
          credentials: "include",
        }).then(function (res) {
          if (!res.ok)
            throw new Error("Unable to update gifts (HTTP " + res.status + ")");
          return res.json();
        })
      : Promise.resolve();
  }
  function isTaggedGift(item) {
    var giftFlag = item && item.properties && item.properties._gift;
    return giftFlag === !0 || String(giftFlag).toLowerCase() === "true";
  }
  function lineKey(item) {
    return item.key || String(item.variant_id);
  }
  function isCartSnapshot(cart) {
    return !!(cart && Array.isArray(cart.items));
  }
  function cartFromEvent(event) {
    var detail = event && event.detail;
    if (isCartSnapshot(detail)) return detail;
    if (detail && isCartSnapshot(detail.cart)) return detail.cart;
    return null;
  }
  function publishCart(cart) {
    if (!isCartSnapshot(cart)) return;
    document.querySelectorAll('[data-fr-gift-quantity]').forEach(function (label) {
      var key = label.getAttribute('data-fr-gift-quantity');
      var item = cart.items.find(function (line) { return line.key === key; });
      var row = label.closest('.cart__item');
      if (!item) { if (row) row.hidden = true; return; }
      label.textContent = label.textContent.replace(/\d+$/, String(item.quantity));
      var input = row && row.querySelector('input[name="updates[]"]');
      if (input) input.value = item.quantity;
    });
    document.dispatchEvent(
      new CustomEvent("fr:cart:hydrate", {
        bubbles: !0,
        detail: { cart: cart, open: !1 },
      }),
    );
  }
  async function performSync(cartSnapshot) {
    var cart = isCartSnapshot(cartSnapshot) ? cartSnapshot : await getCart();
    var neededSamples = {};
    var taggedGiftLines = {};
    var updates = {};
    var bottleCount = 0;
    var discoveryGroups = {};
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._fr_discovery_offer === "fr-discovery-6x2-v1" && props._fr_discovery_group) {
        (discoveryGroups[props._fr_discovery_group] = discoveryGroups[props._fr_discovery_group] || []).push(item);
      }
    });
    var validDiscoveryGroups = new Set(Object.keys(discoveryGroups).filter(function (group) {
      var lines = discoveryGroups[group];
      var packs = lines.filter(function (item) { return Number(item.variant_id || item.id) === 60259428270464 && Number(item.price) === 1000; });
      var samples = lines.filter(function (item) { return Number(item.variant_id || item.id) !== 60259428270464; });
      return packs.length === 1 && samples.length === 6 && new Set(samples.map(function (item) { return item.product_id; })).size === 6 && samples.every(function (item) { return /^(2\s?ml)$/i.test(item.variant_title || "") && Number(item.price) === 0; });
    }));

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._fr_discovery_offer === "fr-discovery-6x2-v1") {
        if (!validDiscoveryGroups.has(props._fr_discovery_group)) updates[lineKey(item)] = 0;
        else if (item.quantity !== 1) updates[lineKey(item)] = 1;
        return;
      }
      if (Number(item.price) === 0 && /^(2\s?ml)$/i.test(item.variant_title || "") && !ALL_GIFT_IDS.has(Number(item.variant_id))) {
        updates[lineKey(item)] = 0;
        return;
      }
      if (ALL_GIFT_IDS.has(Number(item.variant_id))) {
        if (!isTaggedGift(item)) {
          updates[lineKey(item)] = 0;
          return;
        }
        if (!taggedGiftLines[item.variant_id])
          taggedGiftLines[item.variant_id] = [];
        taggedGiftLines[item.variant_id].push(item);
        return;
      }

      var sampleId = FR_GIFT_MAP[item.variant_id];
      if (sampleId !== void 0) {
        bottleCount += item.quantity;
        neededSamples[sampleId] =
          (neededSamples[sampleId] || 0) + item.quantity;
      }
    });

    var desired = Object.assign({}, neededSamples);
    desired[FR_GIFT_BAG_VARIANT_ID] = bottleCount;
    var toAdd = [];

    ALL_GIFT_IDS.forEach(function (giftId) {
      var neededQty = desired[giftId] || 0;
      var lines = taggedGiftLines[giftId] || [];
      if (!lines.length) {
        if (neededQty > 0) {
          toAdd.push({
            id: giftId,
            quantity: neededQty,
            properties: { _gift: "true" },
          });
        }
        return;
      }

      if (lines[0].quantity !== neededQty)
        updates[lineKey(lines[0])] = neededQty;
      for (var i = 1; i < lines.length; i++) updates[lineKey(lines[i])] = 0;
    });

    var hasUpdates = Object.keys(updates).length > 0;
    if (!hasUpdates && !toAdd.length) return cart;

    var finalCart = cart;
    if (hasUpdates) finalCart = await updateLines(updates);
    if (toAdd.length) {
      await addItems(toAdd);
      finalCart = await getCart();
    }
    publishCart(finalCart);
    return finalCart;
  }
  function syncGifts(cartSnapshot) {
    if (syncPromise) {
      syncQueued = !0;
      return syncPromise;
    }

    syncQueued = !1;
    syncPromise = performSync(cartSnapshot)
      .catch(function (err) {
        console.error("[FR Cart Gifts] Sync error:", err);
        throw err;
      })
      .finally(function () {
        syncPromise = null;
        if (syncQueued) {
          syncQueued = !1;
          setTimeout(function () {
            syncGifts().catch(function () {});
          }, 0);
        }
      });
    return syncPromise;
  }
  function debouncedSync(event) {
    var eventCart = cartFromEvent(event);
    if (eventCart) scheduledCart = eventCart;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var cart = scheduledCart;
      scheduledCart = null;
      syncGifts(cart).catch(function () {});
    }, 75);
  }
  ((window.FRCartGifts = window.FRCartGifts || {}),
    (window.FRCartGifts.sync = syncGifts),
    (window.FRCartGifts.buildGiftItemsForPaidItems =
      buildGiftItemsForPaidItems),
    (window.FRCartGifts.addForPaidItems = addForPaidItems),
    document.addEventListener("fr:cart:item-added", debouncedSync),
    document.addEventListener("fr:cart:updated", debouncedSync),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", function () {
          syncGifts().catch(function () {});
        })
      : syncGifts().catch(function () {}));
})();
//# sourceMappingURL=/cdn/shop/t/44/assets/fr-cart-gifts.js.map?v=37172813195220918951781528045

